var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_VOTE_ENTITY_ID } from "../actions/setVoteEntityId";
var initialState = {
    voteEntityId: null,
};
export function getVoteEntityId(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_VOTE_ENTITY_ID:
            return __assign(__assign({}, state), { voteEntityId: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getVoteEntityId.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_VOTE_ENTITY_ID } from "../actions/setVoteEntityId";
var initialState = {
    voteEntityId: null,
};
export function getVoteEntityId(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_VOTE_ENTITY_ID:
            return __assign(__assign({}, state), { voteEntityId: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=getVoteEntityId.js.map